import { CnCheckbox } from './cn-checkbox';
import { CnCheckboxGroup } from './cn-checkbox-group';
// @ts-ignore
CnCheckbox.Group = CnCheckboxGroup;
export { CnCheckbox, CnCheckboxGroup };
